// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body,html{padding:0 0;margin:0 0;background-color:#ebecee;width:100%;height:100%;font-family:Microsoft Yahei;font-size:12px}a{text-decoration:none}i{font-style:inherit}textarea::-webkit-input-placeholder{color:#666}.space_group_item.el-input.el-input--mini{width:48px}i.el-icon-del,span.add_groupTopic{margin-left:20px;color:#4587e7}i.el-icon-del{font-size:18px;position:relative;top:3px;padding:0 10px}", ""]);
// Exports
module.exports = exports;
